import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import '@/assets/styles/theme.scss';
import './plugins/vuefilter.js'
import 'vue-cropper'
import serveIN from "./plugins/interface.js";
import * as filters from './plugins/filters.js'
import DonMessage from './plugins/message.js'
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import "@/assets/icon_font/iconfont";
import "@/assets/icon_font/iconfont.css";
import './plugins/size'
import './plugins/directives.js'
import Vant from 'vant';
import 'vant/lib/index.css';

import AOS from 'aos'
import 'aos/dist/aos.css'
Vue.prototype.aos = AOS

Vue.use(VideoPlayer)
Vue.use(Vant);



Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})
Vue.prototype.$message = DonMessage;
Vue.config.productionTip = false
// Vue.component('CardBox', resolve => require(['@/components/CardBox.vue'], resolve))
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
serveIN.init(Vue);
window.SIF = serveIN;
Vue.prototype.$SIF = serveIN;